<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">
          引取情報{{ irekaeTitle }}
        </h4>
        <section id="history-detail-hikitori">
          <div class="section-child">
            <table class="table">
              <tr v-if="form.HIKITORI_MEI">
                <th><span>名称</span></th>
                <td>
                  <span>{{ form.HIKITORI_MEI }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  form.HIKITORI_TODO_MEI ||
                  form.HIKITORI_SHIKU_MEI ||
                  form.HIKITORI_BANCHI
                "
              >
                <th><span>住所</span></th>
                <td>
                  <span>
                    <span v-if="form.HIKITORI_YUBIN1 && form.HIKITORI_YUBIN2">
                      {{ form.HIKITORI_YUBIN1 }}-{{ form.HIKITORI_YUBIN2 }}
                      <br />
                    </span>
                    {{ form.HIKITORI_TODO_MEI }}{{ form.HIKITORI_SHIKU_MEI
                    }}{{ form.HIKITORI_BANCHI }}
                  </span>
                </td>
              </tr>
              <tr v-if="this.isHikitoriDirect || form.HIKITORI_TEL">
                <th><span>TEL</span></th>
                <td>
                  <span>{{ form.HIKITORI_TEL }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  this.isHikitoriDirect ||
                  (!form.HIKITORI_IS_MASTER_ACTIVE && form.HIKITORI_TANTO_MEI)
                "
              >
                <th><span>担当者名</span></th>
                <td>
                  <span>{{ form.HIKITORI_TANTO_MEI }}</span>
                </td>
              </tr>
              <tr v-if="this.isHikitoriDirect || form.HIKITORI_TANTO_TEL">
                <th><span>担当者TEL</span></th>
                <td>
                  <span>{{ form.HIKITORI_TANTO_TEL }}</span>
                </td>
              </tr>
              <tr v-if="this.isHikitoriDirect || form.HIKITORI_YUSO_KBN">
                <th><span>種別</span></th>
                <td>
                  <span>
                    {{ getText(yusoKbnList, form.HIKITORI_YUSO_KBN) }}
                  </span>
                </td>
              </tr>
              <tr v-if="this.isHikitoriDirect || form.HIKITORI_TEIKYU_BI">
                <th><span>定休日</span></th>
                <td>
                  <span>{{ form.HIKITORI_TEIKYU_BI }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  this.isHikitoriDirect ||
                  form.HIKITORI_EIGYO_KAISI_JIKAN ||
                  form.HIKITORI_EIGYO_SYURYO_JIKAN
                "
              >
                <th><span>営業時間</span></th>
                <td>
                  <span>
                    {{ form.HIKITORI_EIGYO_KAISI_JIKAN }}
                    <span
                      v-if="
                        form.HIKITORI_EIGYO_KAISI_JIKAN ||
                        form.HIKITORI_EIGYO_SYURYO_JIKAN
                      "
                    >
                      〜
                    </span>
                    {{ form.HIKITORI_EIGYO_SYURYO_JIKAN }}
                  </span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA">
                <th><span>ワンプラ落札</span></th>
                <td>
                  <span>
                    {{
                      getText(yesNoList, Number(form.HIKITORI_AA_WANPULA_FLG))
                    }}
                  </span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA && Number(form.HIKITORI_AA_WANPULA_FLG)">
                <th><span>落札日</span></th>
                <td>
                  <span>{{ form.HIKITORI_AA_WANPULA_RAKUSATU_BI }}</span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA && !Number(form.HIKITORI_AA_WANPULA_FLG)">
                <th><span>オークション開催日</span></th>
                <td>
                  <span>{{ form.HIKITORI_AA_KAISAI_BI }}</span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA">
                <th><span>流札車両</span></th>
                <td>
                  <span>
                    {{
                      getText(
                        yesNoList,
                        Number(form.HIKITORI_AA_RYUSATU_SYARYO)
                      )
                    }}
                  </span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA">
                <th><span>POS種別</span></th>
                <td>
                  <span>
                    {{ getText(posKbnList, form.HIKITORI_AA_POS_KBN) }}
                  </span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA">
                <th><span>代行業社名</span></th>
                <td>
                  <span>{{ form.HIKITORI_AA_POS_DAIKO_GYOSHA_MEI }}</span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA">
                <th><span>名義情報</span></th>
                <td>
                  <span>{{ form.HIKITORI_AA_POS_MEIGI_INFO }}</span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA">
                <th><span>POS番号</span></th>
                <td>
                  <span>{{ form.HIKITORI_AA_POS_BANGO }}</span>
                </td>
              </tr>
              <tr v-if="form.isHikitoriAA">
                <th><span>入金状況</span></th>
                <td>
                  <span>
                    {{
                      getText(
                        aaNyukinJyokyoKbnList,
                        Number(form.HIKITORI_AA_NYUKIN_JYOKYO_KBN)
                      )
                    }}
                  </span>
                </td>
              </tr>
              <tr
                v-if="
                  form.isHikitoriAA &&
                  form.HIKITORI_AA_NYUKIN_YOTEI_BI &&
                  Number(form.HIKITORI_AA_NYUKIN_JYOKYO_KBN) === 3
                "
              >
                <th><span>入金予定日</span></th>
                <td>
                  <span>{{ form.HIKITORI_AA_NYUKIN_YOTEI_BI }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  form.isHikitoriAA && form.HIKITORI_AA_NYUKIN_JYOKYO_KBN === 3
                "
              >
                <th><span>入金予定時間</span></th>
                <td>
                  <span>{{ form.HIKITORI_AA_NYUKIN_YOTEI_JIKAN }}</span>
                </td>
              </tr>
              <tr>
                <th>
                  <span>{{ hansyutu }}希望日</span>
                </th>
                <td>
                  <span>{{ form.HANSYUTU_KIBOU_BI }}</span>
                </td>
              </tr>
              <tr>
                <th>
                  <span>{{ hansyutu }}前の事前連絡</span>
                </th>
                <td>
                  <span>
                    {{
                      getText(yesNoHopeList, form.HANSYUTU_JIZEN_RENRAKU_FLG)
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <th><span>備考</span></th>
                <td>
                  <span>{{ form.HIKITORI_BIKOU }}</span>
                </td>
              </tr>
            </table>
          </div>
        </section>
      </div>

      <div class="col-md-6">
        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">
          納車情報{{ irekaeTitle }}
        </h4>
        <section id="history-detail-nosya">
          <div class="section-child">
            <table class="table">
              <tr v-if="form.NOSYA_MEI">
                <th><span>名称</span></th>
                <td>
                  <span>{{ form.NOSYA_MEI }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  form.NOSYA_TODO_MEI ||
                  form.NOSYA_SHIKU_MEI ||
                  form.NOSYA_BANCHI
                "
              >
                <th><span>住所</span></th>
                <td>
                  <span>
                    <span v-if="form.NOSYA_YUBIN1 && form.NOSYA_YUBIN2">
                      {{ form.NOSYA_YUBIN1 }}-{{ form.NOSYA_YUBIN2 }}
                      <br />
                    </span>
                    {{ form.NOSYA_TODO_MEI }}{{ form.NOSYA_SHIKU_MEI
                    }}{{ form.NOSYA_BANCHI }}
                  </span>
                </td>
              </tr>
              <tr v-if="this.isNosyaDirect || form.NOSYA_TEL">
                <th><span>TEL</span></th>
                <td>
                  <span>{{ form.NOSYA_TEL }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  this.isNosyaDirect ||
                  (!form.NOSYA_IS_MASTER_ACTIVE && form.NOSYA_TANTO_MEI)
                "
              >
                <th><span>担当者名</span></th>
                <td>
                  <span>{{ form.NOSYA_TANTO_MEI }}</span>
                </td>
              </tr>
              <tr v-if="this.isNosyaDirect || form.NOSYA_TANTO_TEL">
                <th><span>担当者TEL</span></th>
                <td>
                  <span>{{ form.NOSYA_TANTO_TEL }}</span>
                </td>
              </tr>
              <tr v-if="this.isNosyaDirect || form.NOSYA_YUSO_KBN">
                <th><span>種別</span></th>
                <td>
                  <span>{{ getText(yusoKbnList, form.NOSYA_YUSO_KBN) }}</span>
                </td>
              </tr>
              <tr v-if="this.isNosyaDirect || form.NOSYA_TEIKYU_BI">
                <th><span>定休日</span></th>
                <td>
                  <span>{{ form.NOSYA_TEIKYU_BI }}</span>
                </td>
              </tr>
              <tr
                v-if="
                  this.isNosyaDirect ||
                  form.NOSYA_EIGYO_KAISI_JIKAN ||
                  form.NOSYA_EIGYO_SYURYO_JIKAN
                "
              >
                <th><span>営業時間</span></th>
                <td>
                  <span>
                    {{ form.NOSYA_EIGYO_KAISI_JIKAN }}
                    <span
                      v-if="
                        form.NOSYA_EIGYO_KAISI_JIKAN ||
                        form.NOSYA_EIGYO_SYURYO_JIKAN
                      "
                    >
                      〜
                    </span>
                    {{ form.NOSYA_EIGYO_SYURYO_JIKAN }}
                  </span>
                </td>
              </tr>
              <tr v-if="form.isNosyaAA">
                <th><span>オークション開催日</span></th>
                <td>
                  <span>{{ form.NOSYA_AA_KAISAI_BI }}</span>
                </td>
              </tr>
              <tr v-if="form.isNosyaAA">
                <th><span>POS種別</span></th>
                <td>
                  <span>{{ getText(posKbnList, form.NOSYA_AA_POS_KBN) }}</span>
                </td>
              </tr>
              <tr v-if="form.isNosyaAA">
                <th><span>代行業社名</span></th>
                <td>
                  <span>{{ form.NOSYA_AA_POS_DAIKO_GYOSHA_MEI }}</span>
                </td>
              </tr>
              <tr v-if="form.isNosyaAA">
                <th><span>名義情報</span></th>
                <td>
                  <span>{{ form.NOSYA_AA_POS_MEIGI_INFO }}</span>
                </td>
              </tr>
              <tr v-if="form.isNosyaAA">
                <th><span>POS番号</span></th>
                <td>
                  <span>{{ form.NOSYA_AA_POS_BANGO }}</span>
                </td>
              </tr>
              <tr>
                <th>
                  <span>{{ hannyu }}希望日</span>
                </th>
                <td>
                  <span>{{ form.HANNYU_KIBOU_BI }}</span>
                </td>
              </tr>
              <tr>
                <th>
                  <span>{{ hannyu }}前の事前連絡</span>
                </th>
                <td>
                  <span>
                    {{ getText(yesNoHopeList, form.HANNYU_JIZEN_RENRAKU_FLG) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th><span>備考</span></th>
                <td>
                  <span>{{ form.NOSYA_BIKOU }}</span>
                </td>
              </tr>
            </table>
          </div>
        </section>
      </div>
    </div>

    <h4 class="page-sub-title pl-2 pl-md-4 mt-5" v-if="form.JYUCYU_BIKO !== ''">
      その他留意事項{{ irekaeTitle }}
    </h4>
    <section id="history-detail-other" v-if="form.JYUCYU_BIKO !== ''">
      <div class="section-child">
        <table class="table">
          <tr>
            <th><span>その他留意事項</span></th>
            <td>
              <span>{{ form.JYUCYU_BIKO }}</span>
            </td>
          </tr>
        </table>
      </div>
    </section>

    <h4 class="page-sub-title pl-2 pl-md-4 mt-5">車両情報{{ irekaeTitle }}</h4>
    <section id="history-detail-syaryo">
      <div v-for="(item, index) in form.syaryos" :key="index">
        <confirm-syaryo
          :item="item"
          :form="form"
          class="accordion mb-2"
          type="2"
        />
      </div>
    </section>
  </div>
</template>

<script>
import ConfirmSyaryo from '@/components/order/ConfirmSyaryo'
import Mixin from '../mixin/Mixin'

export default {
  name: 'ConfirmDetail',

  components: {
    ConfirmSyaryo,
  },

  mixins: [Mixin],

  props: {
    /** 入力データ */
    form: {
      type: Object,
      default: null,
    },
  },

  computed: {
    /** 引取先が直接編集か判定 */
    isHikitoriDirect() {
      return (
        this.form.ACTIVE_HIKITORI_TAB === 'DIRECT' && !this.form.HIKITORI_AA_FLG
      )
    },

    /** 納車先が直接編集か判定 */
    isNosyaDirect() {
      return this.form.ACTIVE_NOSYA_TAB === 'DIRECT' && !this.form.NOSYA_AA_FLG
    },

    /** 入れ替え車両用タイトル */
    irekaeTitle() {
      return this.form.isIrekae ? '（下取/入れ替え車両）' : ''
    },

    /** 搬出文言 */
    hansyutu() {
      return this.isLease ? '引取' : '搬出'
    },

    /** 搬入文言 */
    hannyu() {
      return this.isLease ? '納車' : '搬入'
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
  td
    width: 68%
</style>



// WEBPACK FOOTER //
// src/components/order/ConfirmDetail.vue